import cfg from "@root/config";

export type LeadType = 'Бьюти-автопилот' | 'Лидоруб' | 'Интенсив' | 'Агентство (лиды)' | 'Агентство (Вебинарная)' | 'Внедрение';
export type Column = 'НОВЫЕ, дх' | 'Новая заявка' | 'Новая сделка' | 'новые' | 'Ожидаем оплату';
export interface CreateLeadInAmoCrmParams {
    phone: string;
    email: string;
    name: string;
    type: LeadType;
    note?: string | null;
    column: Column;
    requestName: string;
    formId: string;
    integrationId?: string;
    projectId?: string;
    utm?: Record<string, string>;
    url?: string;
}

export async function createLeadInAmoCrm(params: CreateLeadInAmoCrmParams) {
    const url = new URL(`${cfg.apiEndpoint}/noAuth/amocrm/create-lead`);
    const options = {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(params),
    };
    const res = await fetch(url.toString(), options);
    if (res.status > 300) {
        throw new Error(`amocrm/create-lead error: ${res.status}`);
    }
    return res.json();
}